export default (t) => [
  {
    text: '#',
    value: 'row_number',
    sortable: false,
    width: 40
  },
  {
    text: t('Inventory'),
    value: 'name',
    sortable: false,
    width: 200
  },
  {
    text: t('Lot'),
    value: 'lot_number',
    sortable: false,
    width: 120
  },
  {
    text: t('Quantity'),
    value: 'ordered_quantity',
    sortable: false,
    width: 80
  },
  {
    text: t('Unit'),
    value: 'unit',
    sortable: false,
    width: 100
  },
  {
    text: t('Unit Price'),
    value: 'price',
    sortable: false,
    width: 100
  },
  {
    text: t('Discount'),
    value: 'discount',
    sortable: false,
    width: 100
  },
  {
    text: t('Before VAT'),
    value: 'total_before_vat',
    sortable: false,
    width: 100
  },
  {
    text: t('VAT'),
    value: 'total_vat',
    sortable: false,
    width: 100
  },
  {
    text: t('Total'),
    value: 'total',
    sortable: false,
    width: 100
  }
];
